<template>
	<div v-parallax-fit="parallax" class="slide-hand">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/08_grabbinghand_01.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 13000,
						end: 14000,
						fromStyle: { transform: 'translateX(250%)' },
           				toStyle: { transform: 'translateX(87%)' },
						easing: 'linear'
					},
					{
						start: 14500,
						end: 27000,
						fromStyle: { transform: 'translateX(87%)' },
           				toStyle: { transform: 'translateX(250%)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.slide-hand {
		position: absolute;
	    top: 38%;
	    left: 0;
	    transition: all 0.1s linear;
	}

	@media screen and (max-width: 650px) {
		.slide-hand {display: none;}
	}
</style>
